export default __webpack_public_path__ + "static/media/large.9daa89d8.jpg";